<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="6">
          <b-form-group label="From" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker  :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>

        </b-col>
        <b-col lg="6">
          <b-form-group label="To" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate >= toDate">
            Search
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card v-if="buildings.length > 0" no-body>
    <building-report :buildings="buildings"></building-report>
    <ul>
      <li>Total number of people stayed: {{ totalPeople }}</li>
      <li>Total number of rooms occupied: {{ totalRooms }}</li>
      <li>Average rooms occupied: {{ avgOccupied }}</li>
    </ul>
  </b-card>

  <b-card v-if="buildings.length > 0" no-body>
    <building-occupancy-bar-chart :buildings="buildings"></building-occupancy-bar-chart>
  </b-card>

</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import BuildingOccupancyBarChart from './BuildingOccupancyBarChart'
import BuildingReport from './BuildingReport'

export default {
  name: 'OccupancyReport',
  components: {
    BuildingOccupancyBarChart,
    BuildingReport
  },
  data: function() {
    return {
      fromDate: new Date(),
      toDate: this.$moment().add(7, 'days').toDate(),
      buildings: [],
      totalPeople: 0,
      totalRooms: 0,
      avgOccupied: 0
    }
  },
  methods: {
    search() {
      this.buildings = []
      let params = {
        from: this.formatDate(this.fromDate),
        to: this.formatDate(this.toDate)
      }
      Vue.axios.get('admin/reports/occupancy-by-range', {params: params})
      .then(response => {
        this.buildings = response.data.data
        _.each(this.buildings, (building) => {
          this.totalPeople += parseInt(building.total_people)
          this.totalRooms += parseInt(building.total_occupied_rooms)
          this.avgOccupied += building.occcupancy
        })
        this.avgOccupied = this.buildings.length ? this.avgOccupied / this.buildings.length : 0
        this.showSuccessMsg()
      })
      .catch ( error => {
        this.showErrorMsg()
      });
    }
  },
  created () {
  }
}
</script>
